<template>
  <div class="py-10">
    <table class="w-full">
      <thead class="border-b">
        <th class="px-6 font-semibold">{{ $t('OrderNumber')}}</th>
        <th class="px-6 font-semibold">{{ $t('Amount')}}</th>
        <th class="px-6 font-semibold">{{ $t('Status')}}</th>
        <th class="px-6 font-semibold">{{ $t('CreatedAt')}}</th>
      </thead>
      <tbody class="border-b">
        <tr class="border-b" v-for="order in orders" :key="order.id">
          <td class="px-6 py-4 text-teal-400 hover:text-teal-300 text-center">
            <router-link
              :to="{ name: 'order', params: { order_number: order.order_number } }"
            >{{ order.order_number }}</router-link>
          </td>
          <td class="px-6 py-4 text-center">{{ order.amount }} €</td>
          <td class="px-6 py-4 text-center">{{ order.status }}</td>
          <td class="px-6 py-4 text-center">{{ order.created_at }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      orders: []
    };
  },
  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    axios
      .get(`${process.env.VUE_APP_API}/orders`)
      .then(response => {
        // console.log(response.data.data);
        this.orders = response.data.data;
      })
      .catch(error => console.log(error));
  }
};
</script>
<style scoped>
</style>